import React from "react";
import { Reveal } from "../components/Reveal";
import { Overline, SectionTitle } from "../components/site/Primitives";
import SEO from "../components/SEO";

export default function Politica() {
  return (
    <div>
      <SEO title="Política de Privacidade | Barbearia das Estrelas" description="Política de privacidade da Barbearia das Estrelas e Prime Capilar Clinic." />
      <section className="border-b border-white/10 py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <Reveal><Overline className="mb-3">Legal</Overline></Reveal>
          <Reveal delay={0.05}><SectionTitle>Política de Privacidade</SectionTitle></Reveal>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-5 lg:px-8 py-16 space-y-5 text-zinc-300 leading-relaxed">
        <p>Esta Política de Privacidade descreve como a Barbearia das Estrelas e a Prime Capilar Clinic coletam, utilizam e protegem as informações fornecidas por você ao utilizar este site.</p>
        <p><span className="text-white font-600">Coleta de dados.</span> Coletamos informações que você nos fornece voluntariamente por meio dos formulários de contato e avaliação, como nome, telefone/WhatsApp, cidade e interesse de serviço.</p>
        <p><span className="text-white font-600">Uso das informações.</span> Utilizamos seus dados para entrar em contato, agendar atendimentos, indicar a melhor solução para o seu caso e melhorar a sua experiência.</p>
        <p><span className="text-white font-600">Compartilhamento.</span> Não vendemos seus dados. Podemos utilizar ferramentas de comunicação, como o WhatsApp, para o atendimento.</p>
        <p><span className="text-white font-600">Seus direitos.</span> Você pode solicitar a atualização ou exclusão dos seus dados a qualquer momento pelos nossos canais de contato.</p>
        <p>Ao utilizar este site, você concorda com os termos desta Política de Privacidade.</p>
      </section>
    </div>
  );
}
